module.exports = __webpack_public_path__ + "img/bg-hen.96bb0596.png";